import React from "react"
import { connect } from "react-redux"
import Cart from "../../components/shop/cart"

const mapStateToProps = state =>({
  cart: state.currentShop.cart,
  products: state.entities.products
})

const mapDispatchToProps = dispatch => ({
  onDecreaseItem: ({id, index}) => dispatch({type: "SHOP_CART_REMOVE_ITEM", payload: {id, index}}),
  onIncreaseItem: id => dispatch({type: "SHOP_CART_ADD_ITEM", payload: {id}}),
  onRemoveReservation: e => {e.stopPropagation(); dispatch({type: "SHOP_CART.REMOVE_RESERVATION"})},
  onSetDiscount: (index, discount) => dispatch({type: "SHOP_CART_ADD_DISCOUNT", payload: {index, discount}}),
  onCorrectDiscount: index => dispatch({type: "SHOP_CART_CORRECT_DISCOUNT", payload: {index}}),
})

export default connect(mapStateToProps, mapDispatchToProps)(Cart)
